const mediaItems = [
  {
    title: '深度解析：2025娱乐圈塌房年鉴',
    duration: '32:15',
    views: '128.6万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20yearbook%20montage%20of%20entertainment%20scandals%2C%20crimson%20and%20black%20color%20scheme%2C%20newspaper%20headlines%20collage%2C%20moody%20noir%20aesthetic%2C%20cinematic%20composition%2C%20professional%20editorial%20style&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '网红经济链：从爆红到翻车的72小时',
    duration: '18:42',
    views: '96.3万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20visualization%20of%20social%20media%20fame%20collapse%2C%20falling%20charts%20and%20graphs%2C%20moody%20red%20and%20black%20lighting%2C%20cinematic%20noir%2C%20dramatic%20shadows%2C%20professional%20photography&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '吃瓜第一线：某剧组内幕独家揭秘',
    duration: '25:08',
    views: '203.1万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20film%20set%20with%20cameras%20and%20equipment%20in%20shadow%2C%20behind%20the%20scenes%20drama%2C%20moody%20noir%20lighting%2C%20crimson%20accents%2C%20cinematic%20composition&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '吃瓜指南：如何辨别真假爆料信息',
    duration: '14:56',
    views: '75.8万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20detective%20style%20scene%20with%20magnifying%20glass%20over%20documents%2C%20investigation%20theme%2C%20moody%20noir%20lighting%2C%20crimson%20and%20black%20tones%2C%20professional%20editorial%20photography&width=800&height=500&seq=media-04&orientation=landscape',
  },
  {
    title: '年度最炸裂的十个吃瓜名场面',
    duration: '21:30',
    views: '312.4万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20top%20ten%20countdown%20visual%20with%20explosive%20elements%2C%20entertainment%20news%20theme%2C%20moody%20crimson%20and%20black%20lighting%2C%20cinematic%20noir%2C%20dramatic%20composition&width=800&height=500&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">视频专区</h2>
            <p className="text-sm text-foreground-500">热门吃瓜视频合集，深度解读与独家分析</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaItems.map((item, i) => (
              <div key={i} className="bg-background-100 rounded-lg overflow-hidden border border-background-300/40 hover:border-background-300/70 transition-all duration-200 group cursor-pointer">
                <div className="relative aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                    <span className="text-xs text-white/90 bg-black/50 px-2 py-1 rounded">{item.duration}</span>
                    <span className="text-xs text-white/90 flex items-center gap-1">
                      <i className="ri-play-circle-line"></i>
                      {item.views}
                    </span>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                      <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-sm text-foreground-800 group-hover:text-primary-400 transition-colors">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}